<template>
    <CommonHeader class="main_head_block">
		<template v-slot:header>
		<span class="module_heading">Guardrails</span>
        </template>
	</CommonHeader>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue"
export default {
	name:'DefineGuardrailHeader',
    components:{CommonHeader},
}
</script>

<style lang="scss">

</style>
